import PropTypes from "prop-types";

Movie.propTypes = {
  movie: PropTypes.object,
  showtime: PropTypes.object,
};

export default function Movie(props) {
  const { movie, showtime } = props;

  return (
    <div className="movie-detail showtimeDetail-header">
      <div className="row">
        <div className="col-md-7">
          <p>
            <strong>Título Local:</strong>
            <br />
            {movie.title}
          </p>
        </div>
        <div className="col-md-12">
          <div className="showtimeDetail-tooltips">
            <div>{movie.rating}</div>
            <div>{movie.gender}</div>
          </div>
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <p>
            <strong>Sala {showtime.room_name}:</strong>
            <br />
            {movie.version} - {movie.format}
          </p>
        </div>
        <div className="col-4">
          <p>
            <strong>Fecha Función:</strong>
            <br />
            <span className="showtimeDetail-highlighted">
              {showtime.date_string}
            </span>
          </p>
        </div>
        <div className="col-4">
          <p>
            <strong>Hora Función:</strong>
            <br />
            <span className="showtimeDetail-highlighted">
              {showtime.hour_string}
            </span>
          </p>
        </div>
        <div className="col-md-12">
          <hr />
        </div>
      </div>
    </div>
  );
}
